export default IconNumber4Small => `<svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-number-4-small" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
  <path stroke="none" d="M0 0h24v24H0z" fill="none"/>
  <path d="M10 8v3a1 1 0 0 0 1 1h3" />
  <path d="M14 8v8" />
</svg>`;